import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/trendingAndSeasonalOffers';

export const TRENDING_AND_SEASONAL_OFFERS_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const TRENDING_AND_SEASONAL_OFFERS_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;

export const TRENDING_AND_SEASONAL_OFFERS_VIEW = `${rootActionPath}/VIEW`;
